module.exports = __webpack_public_path__ + "media/team-vyl-intro.eecfa625.mp4";